import { useEffect, useRef, useState } from "react";
import { TOAST_MS } from "../../../components/Shell";
import { badgeIcon, isBadgeKey } from "../../footprints";
import { useT } from "../../../i18n";
import { PicoReactionBubble, usePico } from "../../pico";
import type { RoomConnection } from "../lib/connection";

/**
 * P2-S6 룸 배지 반응(SR-ACH-02 · SR-ACH-03) — 룸 서버 `ev {t:"badge", key}`(당사자에게만)를 받으면
 * 피코가 배지 반응(카탈로그 'badge' 규칙 → 없으면 셸 표 🏅 cheer)으로 '📤 첫 올리기 배지를 받았어!'를 3초 보인다.
 * 점수·개수·남과의 비교 없음 — 배지 이름만(DR-01). 뒤에 온 배지는 앞 배지를 바꿔 보인다(겹쳐 쌓지 않음).
 */
export function RoomBadge({ conn }: { conn: RoomConnection | null }) {
  const t = useT();
  const pico = usePico();
  const [shown, setShown] = useState<{ key: string; n: number } | null>(null);
  const react = useRef(pico.react);
  react.current = pico.react;

  useEffect(() => {
    if (!conn) return;
    let n = 0;
    return conn.onEvent((e) => {
      if (e.t !== "badge" || !isBadgeKey(e.key)) return;
      react.current("badge", { toast: false });
      setShown({ key: e.key, n: ++n });
    });
  }, [conn]);

  useEffect(() => {
    if (!shown) return;
    const h = window.setTimeout(() => setShown(null), TOAST_MS);
    return () => window.clearTimeout(h);
  }, [shown]);

  if (!shown) return null;
  const reaction = pico.resolve("badge");
  const name = t(`footprints.badge.${shown.key}`);
  return (
    <div className="pf-room__badge" data-testid="room-badge" data-badge={shown.key}>
      <PicoReactionBubble
        reaction={reaction}
        text={t("room.badgeGot", { icon: badgeIcon(shown.key), name })}
      />
    </div>
  );
}
